import { types } from 'mobx-state-tree';

export const DashboardSections = types.model('DashboardSections', {
  accruals_management: types.optional(types.string, ''),
  all: types.optional(types.string, ''),
  all_reports: types.optional(types.string, ''),
  automation: types.optional(types.string, ''),
  calls: types.optional(types.string, ''),
  catalogs: types.optional(types.string, ''),
  documents: types.optional(types.string, ''),
  gis_zkh: types.optional(types.string, ''),
  house: types.optional(types.string, ''),
  house_chats: types.optional(types.string, ''),
  hr: types.optional(types.string, ''),
  knowledge_base: types.optional(types.string, ''),
  management_accounting: types.optional(types.string, ''),
  module_1c: types.optional(types.string, ''),
  news: types.optional(types.string, ''),
  payments: types.optional(types.string, ''),
  planned_works: types.optional(types.string, ''),
  processing_tasks: types.optional(types.string, ''),
  request_log: types.optional(types.string, ''),
  settings: types.optional(types.string, ''),
  site: types.optional(types.string, ''),
  statistics: types.optional(types.string, ''),
  storage: types.optional(types.string, ''),
  tariffs: types.optional(types.string, ''),
  tickets: types.optional(types.string, ''),
});
